import '@farol-ds/react/index.css'

import { FarolProvider } from '@farol-ds/react'
import { Topbar } from '@jusbrasil/topbar'
import { getPageTitle, SignupFlowProvider } from '@jusbrasil-web/auth/core'
import { ApolloProvider } from '@jusbrasil-web/core-apollo'
import { configureReportWebVitals } from '@jusbrasil-web/core-next'
import { NextFarolProvider } from '@jusbrasil-web/core-next/farol'
import { AppRootProvider } from '@jusbrasil-web/shared-app-root-provider'
import { FeatureFlagsProvider } from '@jusbrasil-web/shared-feature-flags'
import { GTMProvider } from '@jusbrasil-web/shared-gtm'
import { AppProps } from 'next/app'
import Head from 'next/head'
import { useRouter } from 'next/router'

function CustomApp({ Component, pageProps }: AppProps) {
  const { pathname } = useRouter()

  return (
    <AppRootProvider pageProps={pageProps}>
      <Head>
        <title>{getPageTitle(pathname)}</title>
        <meta name="csrf-token" content={pageProps.csrfToken || ''} />
        <meta name="auth-csrf-token" content={pageProps.authCsrfToken || ''} />
        <meta name="signin-upstream" content="bifrost" />
      </Head>

      <NextFarolProvider />

      <FarolProvider>
        <Topbar.Provider pageProps={pageProps}>
          <GTMProvider appId="web-auth" />
          <ApolloProvider pageProps={pageProps}>
            <FeatureFlagsProvider pageProps={pageProps}>
              <SignupFlowProvider>
                <Component {...pageProps} />
              </SignupFlowProvider>
            </FeatureFlagsProvider>
          </ApolloProvider>
        </Topbar.Provider>
      </FarolProvider>
    </AppRootProvider>
  )
}

export const reportWebVitals = configureReportWebVitals()

export default CustomApp
